
import { motion, useScroll, useTransform, useSpring } from 'framer-motion';
import { useRef } from 'react';

const AnimatedSection = ({ children, animation = 'fade-up' }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["0.2 1", "1.1 0"],
  });

  // Default transform values
  let xRange = [0, 0];
  let yRange = [50, 0];
  let scaleRange = [1, 1];

  // Modify ranges based on animation type
  switch (animation) {
    case 'fade-left':
      xRange = [50, 0];
      yRange = [0, 0];
      break;
    case 'fade-right':
      xRange = [-50, 0];
      yRange = [0, 0];
      break;
    case 'fade-up':
      xRange = [0, 0];
      yRange = [60, 0];
      break;
    case 'fade-down':
      xRange = [0, 0];
      yRange = [-50, 0];
      break;
    case 'zoom-in':
      scaleRange = [1, 0.8];
      break;
    case 'zoom-out':
      scaleRange = [1.1, 1];
      break;
    default:
      break;
  }

  const x = useSpring(useTransform(scrollYProgress, [0, 1], xRange), {
    stiffness: 100,
    damping: 20,
  });

  const y = useSpring(useTransform(scrollYProgress, [0, 1], yRange), {
    stiffness: 100,
    damping: 20,
  });

  const scale = useSpring(useTransform(scrollYProgress, [0, 1], scaleRange), {
    stiffness: 100,
    damping: 20,
  });

  return (
    <motion.div ref={ref} style={{ x, y, scale }} className='overflow-hidden'>
      {children}
    </motion.div>
  );
};

export default AnimatedSection;
